// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"10":"e54866cf","23":"32f542f2","210":"bb5a2a71","216":"2d4d154e","422":"5e09590d","484":"c06c8de6","672":"9eba1e51","938":"59c28abd"}[chunkId] + ".css";
};